<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import throttle from "./utils/throttle"
import { debounce } from "@/assets/js/util.js"
import { mapMutations } from "vuex"
import cookieParse from 'cookie'

export default {
  data() {
    return {
      InThisPageTimer: null,
      MouseMoveTimer: null,
    }
  },

  created() {
    let _this = this
    this.MouseMoveTimer = setInterval(() => {
      this.logout()
    }, 3 * 60 * 60 * 1000)
    // 浏览器窗口 切换 事件
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        //状态判断
        this.blur()
      } else {
        this.focus()
      }
    })
    // 鼠标移动事件 + 防抖
    window.onmousemove = throttle(function () {
      // 当鼠标移动的时候，表明就在当前页面了，所以也要清除
      if (_this.InThisPageTimer) clearInterval(_this.InThisPageTimer)
      // 重置鼠标是否移动 定时器
      if (_this.MouseMoveTimer) clearInterval(_this.MouseMoveTimer)
      // 再次监听
      _this.MouseMoveTimer = setInterval(() => {
        _this.logout()
      }, 3 * 60 * 60 * 1000)
    }, 2 * 1000)

    window.__env = process.env.VUE_APP_ENV
    if (window.__env === "uat") {
      window.localStorage.removeItem("__temp_uat_redirct_after_login")
      const cookie = cookieParse.parse(document.cookie)
      if (
        cookie &&
        cookie.__temp_uat_redirct_after_login &&
        cookie.__temp_uat_redirct_after_login !== window.location.origin
      ) {
        setTimeout(() => {
          document.cookie = `__temp_uat_redirct_after_login=; domain=senguo.me; path=/;`
          window.location.href = cookie.__temp_uat_redirct_after_login + '/#/main/'
        }, 2000)
      }
    }
    
    window.originPathname = window.location.hash
  },

  mounted() {
    this.updateWindowHeight()
    window.addEventListener("resize", this.updateWindowHeight)
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowHeight)
  },

  methods: {
    ...mapMutations(["UPDATE_SYSTEMSET_DATA"]),

    blur() {
      // 开启 离开当前页面定时器
      if (this.MouseMoveTimer) clearInterval(this.MouseMoveTimer)
      this.InThisPageTimer = setInterval(() => {
        this.logout()
      }, 3 * 60 * 60 * 1000)
    },
    
    focus() {
      // 清除 离开当前页面定时器
      if (this.InThisPageTimer) clearInterval(this.InThisPageTimer)
      // 并开启 鼠标是否移动定时器
      this.MouseMoveTimer = setInterval(() => {
        this.logout()
      }, 3 * 60 * 60 * 1000)
    },

    logout() {
      this.$fetch
        .jsonRPC({
          url: "/login",
          method: "logout",
        })
        .then(() => {
          this.$router.replace("/login")
          if (watermark) watermark.remove()
        })
        .catch((err) => {
          // this.openMessage(0, '系统错误')
        })
      // 清除所有定时器
      if (this.InThisPageTimer) clearInterval(this.InThisPageTimer)
      if (this.MouseMoveTimer) clearInterval(this.MouseMoveTimer)
    },

    // resize事件处理函数
    updateWindowHeight: debounce(function () {
      this.UPDATE_SYSTEMSET_DATA({
        stateName: "globalData",
        fieldData: {
          height: window.innerHeight,
          width: window.innerWidth,
        },
      })
    }, 500),
  },
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
  padding-right: 0 !important;
  color: #333;
  background-color: #f7f7f7;

  #app {
    height: 100%;
    color: #333;
    background-color: #f7f7f7;
  }
}
body {
  overflow: hidden;
}

@media (max-width: 768px) {
  html,
  body,
  #app {
    min-height: 100%;
  }

  body {
    overflow: auto;
    overscroll-behavior-y: contain;
  }
}
</style>
